import React from 'react'

import PopupMenuButton from "../../popover-menu/popup-menu-button/popup-menu-button"
import PopoverMenuAddAttachment from "./popover-menu"
import ControlButtonStandard, {ControlButtonType} from "../../buttons/control-button/control-button-standard"

type Props = {
    className?  : string
    onSelect    : {(type: 'local' | 'google-drive'):void}
}

export default function ButtonAddAttachmentControlButton(props:Props) {

    const btnComponent = () => (
        <ControlButtonStandard type = {ControlButtonType.ATTACHMENT}
                               hint = "Attach file(s)" />
    )

    return <PopupMenuButton className           = {Classes("add-attachment", props.className)}
                            btnComponent        = {btnComponent}
                            attachment          = "top center"
                            targetAttachment    = "bottom center"
                            offset              = "0 0"
                            menuComponent       = {PopoverMenuAddAttachment}
                            menuParams          = {{
                                onFromComputer      : ()=>{props.onSelect('local')},
                                onFromGoogleDrive   : ()=>{props.onSelect('google-drive')},
                            }}/>
}